import { Currency, FeeCalcType, FeeType, TaxesList } from '@hero/schema';

type FeeTypeConfig = Readonly<{
  /** the calc type for the fee depending on its fee type*/
  calcType: FeeCalcType;
  /** the default fee amount for the customer in SAR */
  defaultAmount: number;
}>;
type FeesConfig = Readonly<{
  [key in FeeType]: Readonly<{
    /** the fees config for a customer ... if undefined, it means the fee is not applicable for a customer */
    customer: FeeTypeConfig | undefined;
    /** the fees config for a carrier ... if undefined, it means the fee is not applicable for a carrier*/
    carrier: FeeTypeConfig | undefined;
  }>;
}>;
const taxes: TaxesList = {
  saudi_vat: {
    id: 'saudi_vat',
    percentage: 0.15,
  },
} as const;

export const feesConfig: FeesConfig = {
  overnight_stay: {
    customer: {
      calcType: 'add_to_subtotal',
      defaultAmount: 500,
    },
    carrier: {
      calcType: 'add_to_subtotal',
      defaultAmount: 400,
    },
  },
  destination_late_arrival: {
    customer: undefined,
    carrier: {
      calcType: 'subtract_from_subtotal',
      defaultAmount: 100,
    },
  },
  destination_waiting_too_long: {
    customer: {
      calcType: 'add_to_subtotal',
      defaultAmount: 150,
    },
    carrier: {
      calcType: 'add_to_subtotal',
      defaultAmount: 100,
    },
  },
  items_insurance: {
    customer: {
      calcType: 'add_to_subtotal',
      defaultAmount: 50,
    },
    carrier: {
      calcType: 'subtract_from_subtotal',
      defaultAmount: 50,
    },
  },
  additional_location: {
    customer: {
      calcType: 'add_to_subtotal',
      defaultAmount: 150,
    },
    carrier: {
      calcType: 'add_to_subtotal',
      defaultAmount: 100,
    },
  },
  other: {
    customer: {
      calcType: 'add_to_subtotal',
      defaultAmount: 0,
    },
    carrier: {
      calcType: 'add_to_subtotal',
      defaultAmount: 0,
    },
  },
} as const;

export const price = {
  /** the allowed number of decimals for all prices in the app
   *
   * 100 means 2 decimal points. Ex 100.98912 will be rounded to 100.99
   */
  priceDecimals: 100,
  /** the number of decimals to be used for the price 2 means 2 decimal points. Ex 100.98912 will be rounded to 100.99 */
  priceDecimalsCount: 2,
  /**
   * default currency
   */
  currency: 'SAR' as Currency,
  /**
   * this cloud be used in discounts or any percentage in the app
   *
   *  Ex: 5.5% will equal to `0.055`
   */
  percentageDecimals: 10000,
  /** the default tax to be used */
  defaultTax: taxes.saudi_vat,
  /** list of taxes */
  taxes,
} as const;
